import { type DriveFile } from '@/shared/DriveTypes';
import { useLayoutEffect, useSyncExternalStore } from 'react';
import { createPortal } from 'react-dom';
import { StaticTree } from '~/components/Tree/StaticTree';

export const TreeMacro = ({
  wiki,
  files,
  content,
  query,
}: {
  wiki: DriveFile;
  files: DriveFile[];
  content: string;
  query: string;
}) => {
  // Attach to the nodes after dangerouslySetInnerHTML has run
  // https://github.com/facebook/react/issues/31600
  // https://github.com/facebook/react/issues/31660
  const node = useSyncExternalStore(
    () => () => {},
    () => {
      if (content.length) {
        const nodes = document.querySelectorAll(query);
        return nodes[0] || null;
      }
      return null;
    },
    () => null
  );

  // We pre-render the tree to avoid a delay showing it to the user, see TreeMacro for details
  // We need to remove this tree as it's replaced with TreeMacro
  useLayoutEffect(() => {
    const tree = document.querySelector('[data-react="Tree"] #rendered-tree');
    if (tree) {
      const sibling = tree.previousElementSibling;
      if (sibling?.tagName.toLowerCase() === 'link') {
        sibling.remove();
      }
      tree.remove();
    }
  }, []);

  if (!node) return null;

  return createPortal(<StaticTree wiki={wiki} files={files} />, node);
};
